import { Action, createReducer, on } from '@ngrx/store';

import { ErrorMessage } from '@priva/appshell';

import { SiteActions } from 'app/report-details/state/actions';
import { AppState } from 'app/state/app.state';

import { OperationTimeDto } from '../report-template/report-template-adapter/model';
import { SiteAsset } from './site.model';

export interface CurrentUserState extends AppState {
    siteState: SiteState;
}

export interface SiteState {
    sites: SiteAsset[];
    isSitesLoaded: boolean;
    sitesError: ErrorMessage | null;
    operationTime: OperationTimeDto | null;
    isOperationTimeLoaded: boolean;
    operationTimeError: ErrorMessage | null;
}

export const initialState: SiteState = {
    sites: [],
    isSitesLoaded: false,
    sitesError: null,
    operationTime: null,
    isOperationTimeLoaded: false,
    operationTimeError: null,
};

const reducer = createReducer<SiteState>(
    initialState,
    on(SiteActions.getSitesSuccess, (state, action): SiteState => {
        const sortedSites = [...action.sites].sort((a, b) => a.name.localeCompare(b.name));
        return {
            ...state,
            sites: sortedSites,
            isSitesLoaded: true,
            sitesError: null,
        };
    }),

    on(SiteActions.getSitesError, (state, action): SiteState => {
        return {
            ...state,
            sites: [],
            isSitesLoaded: true,
            sitesError: action.error,
        };
    }),
);

export function siteReducer(state: SiteState | undefined, action: Action) {
    return reducer(state, action);
}
